<template>
	<v-container>
		<div v-if="auth.loggedIn">
			<v-row>
				<v-col cols="12" sm="12">
					<!-- <v-form v-model="valid"> -->
					<v-form>
						<v-container>
							<v-row justify="center">
								<a
									href="https://support.eclass.ualberta.ca/index.php?/Knowledgebase/Article/View/470/1/creating-quizzes-from-ms-word-files"
									target="_blank"
									>View instructional videos for using the system</a
								><br />
							</v-row>
							<v-row>
								<v-col cols="1" sm="4">
									<v-file-input
										v-model="file"
										label="Exam file"
										prepend-icon="mdi-paperclip"
									>
										<template v-slot:selection="{ text }">
											<v-chip small label color="primary">{{ text }}</v-chip>
										</template>
									</v-file-input>
								</v-col>
								<v-col cols="1" sm="3">
									<v-btn
										@click="upload"
										:disabled="!file || loading"
										:loading="loading"
										color="success"
										>Upload</v-btn
									>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-col>
			</v-row>
			<v-row
				v-if="
					toggleUpload === false || exam.questions.length || examTokens != null
				"
			>
				<ExamCreator
					ref="creator"
					:loading="loading"
					:quizname="qname"
					v-on:xmlgenerate="sendXMLToServer"
				></ExamCreator>
			</v-row>
		</div>
		<div v-else>
			<v-row>
				<v-col cols="12" sm="12">
					<v-col class="mb-4">
						<h1 class="display-2 font-weight-bold mb-3">
							Welcome to the Exam Digitizer
						</h1>

						<p class="subheading font-weight-regular">
							In order to start converting your exam please
							<a href="#" @click="login">login</a> first.
						</p>
					</v-col>
				</v-col>
			</v-row>
		</div>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ExamCreator from "../components/ExamCreator";
const Cookies = require("js-cookie");
const axios = require("axios");
export default {
	components: {
		ExamCreator,
	},
	data: () => ({
		file: null,
		toggleUpload: true,
		loading: false,
	}),
	computed: {
		...mapGetters(["auth"]),
		...mapState(["examTokens", "examId", "exam"]),
	},
	methods: {
		...mapActions(["login"]),
		toBase64: async function(file) {
			let prm = new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsBinaryString(file);
				reader.onload = () => resolve(window.btoa(reader.result));
				reader.onerror = (error) => reject(error);
			});

			return prm;
		},
		upload: async function() {
			console.log(this.file);
			this.loading = true;
			const result = await this.toBase64(this.file).catch((e) => Error(e));
			await this.$store.dispatch("convertExam", { exam: result });

			var creator = this.$refs.creator;
			creator.fetchDataFromVuex();

			this.loading = false;
			this.toggleUpload = false;
		},
		async sendXMLToServer({ xml, finalexam }) {
			const API_CLIENT = axios.create({
				baseURL: "/",
			});

			let convertedfile = await API_CLIENT.post(
				"savexml",
				{
					uuid: this.uuid,
					xml,
					finalexam,
				},
				{
					"Content-Type": "application/json",
					headers: {
						Authorization: Cookies.get("id_token"),
					},
				}
			);
		},
	},
};
</script>
